import dynamic from 'next/dynamic';
import { components } from '@/src/schemas/offer';
import { usePageStore } from '../../zustand';
import { ActiveTemplateEnum } from '@/src/components/Layout/Layout.enums';

const Testimonials = dynamic(() => import('@/components/Testimonials'));

const Text = dynamic(() => import('@/components/Text'));

type SidebarItemsProps = {
  items: components['schemas']['CheckoutSchema']['custom_fields']['items'];
  testimonials?: components['schemas']['CheckoutSchema']['testimonials'];
};

const Sidebar = (props: SidebarItemsProps) => {
  const activeTemplate = usePageStore((state) => state.activeTemplate);
  const { items, testimonials } = props;
  return (
    <>
      {items?.map((item, index) => {
        const displayOn = {
          desktop: item.display_on?.desktop ?? true,
          mobile: item.display_on?.mobile ?? true,
        };
        return (
          isDisplayComponent(activeTemplate, displayOn) &&
          (item.type === 'text' ? (
            <Text key={index} heading={item.title!} text={item.text!} />
          ) : item.type === 'testimonial' ? (
            <Testimonials
              key={index}
              heading={item.title!}
              testimonials={testimonials!}
            />
          ) : null)
        );
      })}
    </>
  );
};

export const isDisplayComponent = (
  activeTemplate,
  displayOn = { desktop: true, mobile: true }
) =>
  ([
    ActiveTemplateEnum.DESKTOP_TWO_COLUMN,
    ActiveTemplateEnum.DESKTOP_TWO_STEP,
  ].includes(activeTemplate as ActiveTemplateEnum) &&
    displayOn?.desktop) ||
  (activeTemplate === ActiveTemplateEnum.MOBILE && displayOn?.mobile);

export default Sidebar;
